if (!customElements.get('product-information-tabs')) {
  class ProductInformationTabs extends HTMLElement {
    constructor() {
      super();
      this.tabButtons = Array.from(this.querySelectorAll('[data-tab-target]'));
      this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));

      this.tabButtons.forEach((button) => {
        button.addEventListener('click', () => this.activate(button));
        button.addEventListener('keydown', (event) => this.onKeydown(event, button));
      });
    }

    activate(button) {
      const target = button.getAttribute('data-tab-target');

      this.tabButtons.forEach((btn) => {
        const isActive = btn === button;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        btn.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.panels.forEach((panel) => {
        const isActive = panel.getAttribute('data-tab-panel') === target;
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    onKeydown(event, currentButton) {
      const currentIndex = this.tabButtons.indexOf(currentButton);
      let newIndex = null;

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        newIndex = (currentIndex + 1) % this.tabButtons.length;
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        newIndex = (currentIndex - 1 + this.tabButtons.length) % this.tabButtons.length;
      } else if (event.key === 'Home') {
        newIndex = 0;
      } else if (event.key === 'End') {
        newIndex = this.tabButtons.length - 1;
      }

      if (newIndex !== null) {
        event.preventDefault();
        const newButton = this.tabButtons[newIndex];
        newButton.focus();
        this.activate(newButton);
      }
    }
  }

  customElements.define('product-information-tabs', ProductInformationTabs);
}
